import "./Applications.module.css";
import Navigation from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import Footer from "@/reusable_sections/Footer";
import ApplicationsIntro from "./sections/ApplicationsIntro";
import Industries from "./sections/Industries";
import SelectionConsiderations from "./sections/SelectionConsiderations";
import QuoteBand from "./sections/QuoteBand";
export default function ApplicationsPage() {
  return <div>
      <Navigation />
      <PageBreadcrumb page="Applications" />
      <ApplicationsIntro />
      <Industries />
      <SelectionConsiderations />
      <QuoteBand />
      <Footer />
    </div>;
}